import React from 'react';
import SEO from '../SEO';
import { seoConfig, generateBreadcrumbJsonLd } from '../../utils/seoData';

const KVKKPage: React.FC = () => {
  const breadcrumbJsonLd = generateBreadcrumbJsonLd([
    { name: 'Ana Sayfa', url: 'https://winnomi.com' },
    { name: 'KVKK Aydınlatma Metni', url: 'https://winnomi.com/kvkk-aydinlatma-metni' },
  ]);

  return (
    <>
      <SEO
        {...seoConfig.kvkk}
        jsonLd={[
          breadcrumbJsonLd,
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'KVKK Aydınlatma Metni',
            description: seoConfig.kvkk.description,
            url: 'https://winnomi.com/kvkk-aydinlatma-metni',
            datePublished: '2025-11-09',
            dateModified: '2025-11-09',
          },
        ]}
      />
      <main className="min-h-screen bg-slate-950 text-slate-100">
      <div className="max-w-5xl mx-auto px-6 py-24 space-y-12">
        <header className="space-y-4">
          <p className="text-sm uppercase tracking-widest text-purple-300">KVKK Aydınlatma Metni</p>
          <h1 className="text-3xl md:text-4xl font-semibold text-white">
            Winnomi AI KVKK Aydınlatma Metni
          </h1>
          <p className="text-slate-400">Güncelleme tarihi: 09 Kasım 2025</p>
          <p className="text-slate-300 leading-relaxed">
            6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) ve ilgili mevzuat kapsamında veri sorumlusu
            olarak TARIK ÇEKEMOĞLU CONCEPTION TEAM DANIŞMANLIK HİZMETLERİ (“Şirket”) tarafından kişisel
            verilerinizin işlenmesine ilişkin aşağıdaki hususlarda bilgilendirildiğinizi ve aydınlatıldığınızı önemle
            bildiririz.
          </p>
        </header>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">1. Veri Sorumlusunun Kimliği</h2>
          <div className="space-y-2 text-slate-300 leading-relaxed">
            <p><strong className="text-white">Unvan:</strong> TARIK ÇEKEMOĞLU CONCEPTION TEAM DANIŞMANLIK HİZMETLERİ</p>
            <p><strong className="text-white">Adres:</strong> MASLAK MAH. AOS 55. SK. 42 MASLAK A BLOK NO: 2 İÇ KAPI NO: 25 SARIYER / İSTANBUL PK: 34475</p>
            <p><strong className="text-white">Telefon:</strong> +90 (546) 597 56 43</p>
            <p><strong className="text-white">E-posta:</strong> info@winnomi.com</p>
            <p><strong className="text-white">KEP:</strong> tarik.cekemoglu@hs01.kep.tr</p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">2. İşlenen Kişisel Veri Kategorileri</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>Kişisel verileriniz, aşağıdaki kategorilerle sınırlı olmamak üzere işlenebilir:</p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Kimlik verileri (ad, soyad, TCKN*, doğum tarihi)</li>
              <li>İletişim verileri (e-posta adresi, telefon numarası, açık adres)</li>
              <li>Müşteri işlem verileri (üyelik bilgileri, işlem geçmişi, destek kayıtları)</li>
              <li>Finans verileri (ödeme bilgileri, fatura bilgileri, IBAN*)</li>
              <li>Pazarlama verileri (kampanya tercihleri, çerez verileri, geri bildirimler)</li>
              <li>Lokasyon ve cihaz verileri (IP adresi, cihaz kimliği, tarayıcı verileri)</li>
              <li>Görsel ve işitsel veriler (çağrı merkezi kayıtları, destek görüşmeleri)</li>
            </ul>
            <p className="text-xs text-slate-500">* Bu veriler yalnızca ilgili hizmetlerin sunulması zorunlu olduğu ölçüde talep edilir.</p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">3. Kişisel Verilerin İşlenme Amaçları</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Platform hizmetlerinin sunulması, üyelik oluşturulması ve yönetimi</li>
              <li>Kimlik doğrulama, giriş güvenliği ve hesap bütünlüğünün sağlanması</li>
              <li>Yapay zeka destekli analizlerin sunulması ve kişiselleştirilmiş içerik önerileri</li>
              <li>Ödeme ve faturalama süreçlerinin yürütülmesi, finansal kayıtların tutulması</li>
              <li>Müşteri ilişkileri yönetimi, destek talepleri ve şikayet yönetimi</li>
              <li>Pazarlama iletişimleri, kampanya ve etkinlik duyurularının iletilmesi</li>
              <li>Ürünün geliştirilmesi, performans ve kullanım analizi</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi, uyuşmazlıkların çözümü</li>
              <li>Yetkili kurumlara mevzuat kapsamında bilgi verilmesi</li>
            </ul>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebepler</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Kişisel verileriniz, Platform üzerindeki formlar, üyelik süreçleri, mobil uygulama kullanımı, çağrı
              merkezi, destek kanalları, çerez teknolojileri, sosyal medya entegrasyonları ve sözleşmesel
              ilişkiler aracılığıyla otomatik ya da otomatik olmayan yollarla elde edilmektedir.
            </p>
            <p>İşleme faaliyetleri aşağıdaki hukuki sebeplere dayanmaktadır:</p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Kanunlarda açıkça öngörülmesi</li>
              <li>Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması</li>
              <li>Hukuki yükümlülüklerin yerine getirilmesi</li>
              <li>Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması</li>
              <li>Temel hak ve özgürlüklere zarar vermemek kaydıyla veri sorumlusunun meşru menfaatleri</li>
              <li>Açık rıza (özellikle pazarlama iletişimleri, çerezler ve üçüncü taraf paylaşımı)</li>
            </ul>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">5. Kişisel Verilerin Aktarılması</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>Kişisel verileriniz, KVKK’nın 8. ve 9. maddelerinde belirtilen şartlara uygun olarak aktarılabilir:</p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Bulut altyapısı, yazılım ve bakım hizmeti sağlayıcıları</li>
              <li>Ödeme kuruluşları, bankalar ve mali danışmanlar</li>
              <li>İş ortakları, tedarikçiler ve destek hizmeti alınan şirketler</li>
              <li>Hukuken yetkili kamu kurum ve kuruluşları</li>
              <li>Yurtdışına veri aktarımı gereken durumlarda açık rızanız ve Kurul tarafından belirlenen yeterlilik kararları doğrultusunda</li>
            </ul>
            <p>
              Aktarım işlemlerinde veri güvenliğini sağlamak amacıyla teknik ve idari tedbirler alınmakta,
              sözleşmesel güvenceler tesis edilmektedir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">6. Veri Saklama Süreleri</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Kişisel verileriniz, işleme amaçlarının gerektirdiği süre boyunca veya ilgili mevzuatta öngörülen asgari
              sürelerle sınırlı olarak saklanır. Sürelerin sonunda, veriler mevzuata uygun yöntemlerle silinir,
              yok edilir veya anonim hale getirilir.
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Üyelik verileri: Üyelik sona erdikten sonra 10 yıl</li>
              <li>Finans/muhasebe kayıtları: Vergi mevzuatı gereği 10 yıl</li>
              <li>Log ve trafik verileri: 5651 sayılı Kanun uyarınca en az 1 yıl</li>
              <li>Destek talepleri: Talebin kapanmasından itibaren 3 yıl</li>
            </ul>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">7. Veri Güvenliğini Sağlamak İçin Alınan Tedbirler</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>Verileriniz aşağıdaki teknik ve idari tedbirlerle korunmaktadır:</p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Şifreleme, tokenizasyon ve maskeleme teknolojileri</li>
              <li>Yetkilendirme, erişim kontrolü ve loglama mekanizmaları</li>
              <li>KVKK farkındalık eğitimleri ve gizlilik sözleşmeleri</li>
              <li>Düzenli zafiyet taraması, sızma testleri ve yedekleme</li>
              <li>İç ve dış denetim süreçleri, olay müdahale planları</li>
            </ul>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">8. İlgili Kişi Hakları</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              KVKK’nın 11. maddesi uyarınca, Şirket’e başvurarak kişisel verilerinize ilişkin aşağıdaki hakları
              kullanabilirsiniz:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Kişisel veri işlenip işlenmediğini öğrenme</li>
              <li>İşlenmişse buna ilişkin bilgi talep etme</li>
              <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurtiçinde veya yurtdışında aktarıldığı üçüncü kişileri bilme</li>
              <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
              <li>Silinmesini veya yok edilmesini talep etme</li>
              <li>Aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
              <li>Otomatik sistemler vasıtasıyla analiz sonucuna itiraz etme</li>
              <li>Zararın giderilmesini talep etme</li>
            </ul>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">9. Başvuru Yöntemleri</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Hak taleplerinizi KVKK ve Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ’e uygun
              olarak aşağıdaki yöntemlerle iletebilirsiniz:
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              <li>Yazılı başvuru (ıslak imzalı) ile “Veri Sorumlusu” adresine posta</li>
              <li>Kayıtlı Elektronik Posta (KEP) adresi üzerinden güvenli elektronik imza ile</li>
              <li>Güvenli elektronik imza veya mobil imza ile imzalanmış e-posta</li>
              <li>Şirket sisteminde kayıtlı e-posta adresinizden infi@winnomi.com adresine</li>
            </ul>
            <p>
              Başvurular, başvurunun Şirket’e ulaştığı tarihten itibaren en geç 30 gün içinde sonuçlandırılır.
              Başvurunun maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu tarafından belirlenen
              tarifedeki ücret yansıtılabilir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">10. Değişiklikler</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Bu aydınlatma metni, mevzuat hükümlerindeki değişiklikler veya veri işleme süreçlerinde oluşabilecek
              güncellemeler doğrultusunda revize edilebilir. Güncel sürüm Platform’da yayınlanır ve Platform
              kullanıcılarının erişimine açık tutulur.
            </p>
          </div>
        </section>
      </div>
    </main>
    </>
  );
};

export default KVKKPage;

